export default [
  {
    header: 'menu.posting_service',
  },
  {
    title: 'multi_poster.menu',
    icon: 'Share2Icon',
    route: 'owner:multi-poster',
  },
  {
    title: 'poster.post',
    icon: 'Edit3Icon',
    route: 'owner:poster',
  },
  {
    title: 'poster.published-post',
    icon: 'TrelloIcon',
    route: 'owner:published-posts',
  },
  {
    title: 'instagram.scheduled-post',
    icon: 'ClockIcon',
    route: 'owner:scheduled-posts',
  },
  {
    title: 'poster.fb-scheduled-post',
    icon: 'ClockIcon',
    route: 'owner:fb-scheduled-posts',
  },
]
